import ProductListWrapperContainer from './ProductListWrapperContainer';
export default ProductListWrapperContainer;